<h2 class="bd-title">Email Notification Profiles</h2>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if ({ isLoading: loadingService.isAnySpinnerActive$ | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-grid [gridOptions]="gridOptions" [rowData]="profiles" [searchable]="true">
  <div topBarLeft>
    <button
      id="createButton"
      class="btn btn-primary btn-sm"
      [disabled]="isReadOnly"
      (click)="openAddEditModal()"
      placement="top"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Create a new email profile"
    >
      <span class="fa fa-plus mr-1" aria-hidden="true"></span>Create new
    </button>
  </div>
</coso-grid>
} }

<ng-template #actionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm" role="group">
    <button
      [id]="'editActionButton#' + params.data.name"
      [attr.aria-label]="(isReadOnly ? 'View email profile ' : 'Edit email profile ') + params.data.name"
      class="btn btn-dark mr-1"
      data-toggle="tooltip"
      [title]="isReadOnly ? 'View email profile' : 'Edit email profile'"
      (click)="openAddEditModal(params.data)"
    >
      <span class="fa fa-fw {{ isReadOnly ? 'fa-eye' : 'fa-edit' }}" aria-hidden="true"></span>
    </button>
    <button
      [id]="'deleteActionButton#' + params.data.name"
      [attr.aria-label]="'Delete email profile ' + params.data.name + '?'"
      class="btn btn-danger"
      data-toggle="tooltip"
      title="Delete email profile"
      [disabled]="isReadOnly || params.data.isUsedInConfiguration"
      (click)="openDeleteModal(params.data)"
    >
      <span class="fa fa-fw fa-trash" aria-hidden="true"></span>
    </button>
  </div>
</ng-template>
